import React from 'react';
import { Link } from 'react-router-dom';
import { ShoppingCart, User, ChevronDown, LogOut, LayoutDashboard, Package, ShieldCheck } from 'lucide-react';
import { useCart } from '../context/CartContext';
import { useUserAuth } from '../context/UserAuthContext';
import { useI18n } from '../context/I18nContext';

export function CartButton() {
  const { count } = useCart();
  return (
    <Link to="/cart" className="relative flex items-center justify-center w-10 h-10 rounded-full border border-white/10 text-white/70 hover:text-[#f4d896] hover:border-[#e4b44e]/40 transition">
      <ShoppingCart className="w-4 h-4" />
      {count > 0 && (
        <span className="absolute -top-1 -right-1 w-5 h-5 rounded-full bg-[#e4b44e] text-[#17140b] text-[10px] font-black flex items-center justify-center">{count}</span>
      )}
    </Link>
  );
}

export function UserButton() {
  const { user } = useUserAuth();
  const { tr } = useI18n();
  if (!user) return null;
  return (
    <div className="relative group">
      <button className="flex items-center gap-2 h-10 px-3 rounded-full border border-[#e4b44e]/30 bg-[#e4b44e]/5 text-white hover:bg-[#e4b44e]/15 transition">
        <div className="w-6 h-6 rounded-full bg-gradient-to-br from-[#f0c766] to-[#a97a1f] flex items-center justify-center text-[#17140b] text-xs font-black">
          {(user.name || user.email)[0].toUpperCase()}
        </div>
        <span className="text-xs font-bold hidden md:inline max-w-[80px] truncate">{user.name || user.email.split('@')[0]}</span>
        <ChevronDown className="w-3 h-3 opacity-70" />
      </button>
      <div className="absolute right-0 top-full pt-3 opacity-0 pointer-events-none group-hover:opacity-100 group-hover:pointer-events-auto transition-all z-50">
        <div className="min-w-[200px] rounded-xl bg-[#0d0d13]/95 backdrop-blur-xl border border-[#e4b44e]/20 p-2 shadow-2xl">
          <Link to="/account" className="flex items-center gap-2 px-3 py-2 text-sm text-white/80 hover:text-[#f4d896] hover:bg-[#e4b44e]/10 rounded-lg transition"><LayoutDashboard className="w-4 h-4" /> {tr('header.user_menu_account', 'Hesabım')}</Link>
          <Link to="/account/orders" className="flex items-center gap-2 px-3 py-2 text-sm text-white/80 hover:text-[#f4d896] hover:bg-[#e4b44e]/10 rounded-lg transition"><Package className="w-4 h-4" /> {tr('header.user_menu_orders', 'Siparişlerim')}</Link>
          {user.is_admin && (
            <Link to="/admin" className="flex items-center gap-2 px-3 py-2 text-sm text-emerald-400 hover:text-emerald-300 hover:bg-emerald-400/10 rounded-lg transition"><ShieldCheck className="w-4 h-4" /> Admin Paneli</Link>
          )}
          <button onClick={() => { localStorage.removeItem('aegis_user_token'); window.location.href = '/'; }} className="w-full flex items-center gap-2 px-3 py-2 text-sm text-white/80 hover:text-red-400 hover:bg-red-500/10 rounded-lg transition"><LogOut className="w-4 h-4" /> {tr('header.user_menu_logout', 'Çıkış')}</button>
        </div>
      </div>
    </div>
  );
}
